<div class="login row">
  <div class="BGLogin col">
    <img src="assets/svg/BG-Login.png" />
  </div>

  <div class="Login_BoxForm col-3">
    <div class="BoxForm_Content">
      <div class="BoxForm_Title">
        <img src="assets/svg/icon_login.svg">
        <p data-e2e="first-acess-title">Concluir criação de acesso</p>
      </div>
      <div class="BoxForm_Form">
        <form class="form-login" [formGroup]="formFirstAccess" (ngSubmit)="onSubmit()">
          <div class="login-fa-cpf">
            <span data-e2e="fill-cpf-label" class="login-fa-cpf-resp">Preencha o CPF de <a href="#" target="_blank" rel="noopener noreferrer">cadastro</a>.</span>
          </div>
          <div class="input-group mb-3">
            <p class="Form_TitleInput">CPF</p>
            <div class="input-group-prepend Form_Prepend">
              <span class="input-group-text"><img src="assets/svg/icon_login_user.svg" class="IconInput"></span>
            </div>
            <input data-e2e="cpf-input" formControlName="documentNumber" type="text" class="form-control FormInput_Usuario" placeholder="" aria-label="Username"
              aria-describedby="basic-addon1">
          </div>
          @if (enableBtnEnviar) {
            <app-generic-button
              [description]="'ENVIAR'"
              [isBtnWithBorder]="true"
              (emitterEvtClick)="onSubmit()"
              [data-e2e]="'cpf-submit-btn'"
              [id-html]="'cpf-submit-btn'"
              [customWidthSize]="'20rem'">
            </app-generic-button>
          }
        </form>

        @if (enableBtnEnviar) {
          <div class="FormLogin_Divider">
            <p>OU</p>
          </div>
        }

        <div class="Login_ForgotPassword">
          <a data-e2e="back-to-login-btn" href="login" class="Login_btn_ForgotPassword">
            Voltar
          </a>
        </div>

        <div class="BoxForm_LogoRepomResponsive">
          <img src="assets/svg/footer_logo_repom.svg">
        </div>
      </div>
    </div>
    <!--BoxForm_Content-->
  </div>
  <!--Login_BoxForm-->
  <!-- **************** Login | End **************** -->
</div>

